import WorkEmailVerification from './WorkEmailVerification';

export default WorkEmailVerification;
